import { Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { createEffectFactory } from '@recruitee/ngrx';

import { OfferLanguagesHttpService } from './offer-languages-http.service';
import { OfferLanguagesActions } from './offer-languages.store';

@Injectable({
  providedIn: 'root',
})
export class OfferLanguagesEffects {
  public effects = createEffectFactory(OfferLanguagesActions, this.actions$);

  public fetchOne$ = this.effects(OfferLanguagesActions.fetchOne, ({ payload }) =>
    this.offerLanguagesHttpService.fetchOne$(payload.offerId).pipe(
      map(response => ({
        data: {
          setup: response.setup,
          offerId: response.offerId,
        },
      })),
    ),
  );

  public toggle$ = this.effects(OfferLanguagesActions.toggle, ({ payload }) =>
    this.offerLanguagesHttpService.toggleLanguageItem$(payload).pipe(
      switchMap(response =>
        of(
          OfferLanguagesActions.toggleSuccess({
            payload: {
              offerId: payload.offerId,
              data: response,
            },
          }),
        ),
      ),
      catchError(error =>
        of(
          OfferLanguagesActions.toggleFailed({
            payload: {
              offerId: payload.offerId,
              error,
            },
          }),
        ),
      ),
    ),
  );

  public setAsPrimary$ = this.effects(
    OfferLanguagesActions.setAsPrimary,
    ({ payload: { offerId, code } }) =>
      this.offerLanguagesHttpService.setPrimaryLanguage$({ offerId, code }).pipe(
        switchMap(() =>
          of(OfferLanguagesActions.setAsPrimarySuccess({ payload: { offerId, code } })),
        ),
        catchError(error =>
          of(OfferLanguagesActions.setAsPrimaryFailed({ payload: { error, offerId } })),
        ),
      ),
  );

  public refreshOne$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OfferLanguagesActions.setAsPrimarySuccess, OfferLanguagesActions.toggleSuccess),
      switchMap(({ payload }) => [
        OfferLanguagesActions.fetchOne({ payload: { offerId: payload.offerId } }),
      ]),
    ),
  );

  constructor(
    private actions$: Actions,
    private offerLanguagesHttpService: OfferLanguagesHttpService,
  ) {}
}
